// Forever Forward — spotlight
// Moves a light beam with the pointer/touch, and lets it drift on its own
// while idle. Writes --ff-x / --ff-y (percentages) consumed by the CSS mask.

(function () {
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initSpot(el) {
    if (!el || el.dataset.ffSpotReady === 'true') return;
    el.dataset.ffSpotReady = 'true';

    var drift = el.dataset.ffDrift !== 'false';
    var idleAfter = 2200;

    // Current + target position, in percent of the section box.
    var cur = { x: 50, y: 50 };
    var tgt = { x: 50, y: 50 };
    var lastMove = 0;
    var raf = null;
    var seed = Math.random() * 1000;

    function set(x, y) {
      el.style.setProperty('--ff-x', x.toFixed(2) + '%');
      el.style.setProperty('--ff-y', y.toFixed(2) + '%');
    }

    set(cur.x, cur.y);

    function point(e) {
      var r = el.getBoundingClientRect();
      tgt.x = ((e.clientX - r.left) / r.width) * 100;
      tgt.y = ((e.clientY - r.top) / r.height) * 100;
      lastMove = Date.now();
      el.classList.add('is-touched');
    }

    el.addEventListener('pointermove', point);
    el.addEventListener('pointerdown', point);

    el.addEventListener('pointerleave', function () {
      lastMove = 0; // hand it straight back to the drift
    });

    function loop(t) {
      // Idle: describe a slow lissajous path so the beam keeps breathing.
      if (drift && Date.now() - lastMove > idleAfter) {
        var k = (t + seed) / 1000;
        tgt.x = 50 + Math.sin(k * 0.42) * 26;
        tgt.y = 50 + Math.cos(k * 0.31) * 20;
      }

      cur.x += (tgt.x - cur.x) * 0.08;
      cur.y += (tgt.y - cur.y) * 0.08;
      set(cur.x, cur.y);

      raf = window.requestAnimationFrame(loop);
    }

    if (reduced) {
      // No chase, no drift — park the beam over the content.
      set(50, 50);
      el.classList.add('is-static');
      return;
    }

    raf = window.requestAnimationFrame(loop);

    // Stop animating while off-screen.
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            if (!raf) raf = window.requestAnimationFrame(loop);
          } else if (raf) {
            window.cancelAnimationFrame(raf);
            raf = null;
          }
        });
      }, { threshold: 0 }).observe(el);
    }
  }

  function init() {
    document.querySelectorAll('[data-ff-spotlight]').forEach(initSpot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
